import { useEconomyStore } from '@/state/useEconomyStore'
import './InteractionPrompt.css'

const STRUCTURE_LABELS: Record<string, [string, string]> = {
  castle:       ['Keep', 'View village overview'],
  house:        ['Home', "Visit the villager's home"],
  trading_post: ['Trading Post', 'Buy and sell goods'],
  church:       ['Chapel', 'Seek healing and blessings'],
  pub:          ['Tavern', 'Food, drink, and rumors'],
  armory:       ['Smithy', 'Forge weapons and tools'],
  stable:       ['Stable', 'Trade livestock'],
  barn:         ['Storehouse', 'Bulk storage and trade'],
  dock:         ['Harbor', 'Manage ship and cargo'],
  farm:         ['Farmstead', 'Buy fresh produce'],
  pasture:      ['Paddock', 'Collect from livestock'],
}

export function InteractionPrompt() {
  const target = useEconomyStore((s) => s.nearestTarget)
  const panelOpen = useEconomyStore((s) => s.panelOpen)

  if (!target || panelOpen) return null

  const [label, subtitle] = STRUCTURE_LABELS[target.structureType] ?? [target.structureType, '']

  return (
    <div className="interaction-prompt">
      <div className="interaction-prompt__key">E</div>
      <div className="interaction-prompt__text">
        <div className="interaction-prompt__label">{label}</div>
        <div className="interaction-prompt__subtitle">{subtitle}</div>
      </div>
    </div>
  )
}
